import styled from "styled-components"
import starFilled from "../../images/svg/star-filled.svg"
import starOutline from "../../images/svg/star-outline.svg"
import StarRatings from "react-star-ratings"
import { useSelector } from "react-redux"
const Container = styled.div`
  cursor: pointer;
  position: relative;
  width: max-content;



    img{
        width: 14px;
        height: 14px;
    }

    .user-average-infobox{
      position: absolute;
      left: 80px;
      top: -15px;
      width: 320px;
      height: auto;
      background-color: ${({ theme }) => theme.mainBgColor};
      -webkit-box-shadow: 0px 0px 9px 0px ${({ theme }) => theme.mainTextColor}; 
      box-shadow: 0px 0px 9px 0px ${({ theme }) => theme.mainTextColor};
      border-radius: 5px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      z-index: 20;

      .main-info-item{
          display: flex;
          align-items: flex-end;
          div{
              font-weight: var(--font-weight-lg);
              font-size: var(--font-size-md);
              margin-right: 10px;
              color: ${({ theme }) => theme.mainTextColor};

          }
          span{
              font-size: 12px;
              color:${({ theme }) => theme.mainTextColor};
          }
      }

      .info-item{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;


          .key{
              color:${({ theme }) => theme.mainTextColor};
              font-weight: var(--font-weight-md);
              font-size: var(--font-size-sm);
          }

          .star-container{

          }
      }


      &::after {
          content: '';
          position: absolute;
          top: 15px;
          left: -7px;
          transform: scale(1) rotate(50deg);
          border-width: 10px;
          border-style: solid;
          border-color: ${({ theme }) => theme.mainBgColor};
          border-radius: 5px;   
          z-index:1;         
          -webkit-box-shadow: -21px 0px 20px 0px ${({ theme }) => theme.mainTextColor}; 
          box-shadow: -8px 8px 16px -7px ${({ theme }) => theme.mainTextColor};
      }
  }
`
    
const RatingContainer = ({rating, item, isRatingHover, setIsRatingHover, hovered}) => {
    const {theme } = useSelector((state)=>state.layout)
  return (
    <Container theme={theme} onMouseEnter={() => hovered && setIsRatingHover(true)} onMouseLeave={() => hovered && setIsRatingHover(false)}>
    <StarRatings
      rating={rating} // Toplam değerlendirme
      starRatedColor="#E85446" // Tamamen boyalı yıldızların rengi
      starEmptyColor="#aaa3a3" // Boş yıldızların rengi
      starDimension="23px" // Yıldız boyutu
      starSpacing="2px" // Yıldızlar arası boşluk
    />
      {
        isRatingHover && 
            <div className="user-average-infobox"  onMouseEnter={() => hovered && setIsRatingHover(true)} onMouseLeave={() => hovered && setIsRatingHover(false)}>
                <div className="main-info-item">
                <div>{((item.communicationandCustomerService + item.deliveryTimeandReliability + item.equipmentCondition) / 3 )?.toFixed(1)}</div> <span>Ortalama Puan</span>
                </div>
                <div className="info-item">
                    <div className="key">Teslimat Süresi ve Güvenilirlik</div>
                    <div className="star-container">
                        <RatingContainer rating={item.deliveryTimeandReliability} hovered={false}/>
                    </div>
                </div>
                <div className="info-item">
                    <div className="key">İletişim ve Müşteri Hizmetleri</div>
                    <div className="star-container">
                        <RatingContainer rating={item.communicationandCustomerService} hovered={false}/>
                    </div>
                </div>
                <div className="info-item">
                    <div className="key">Ekipman Durumu</div>
                    <div className="star-container">
                        <RatingContainer rating={item.equipmentCondition} setIsRatingHover={setIsRatingHover} hovered={false}/>
                    </div>
                </div>
            </div>
      }
    </Container>
  )
}

export default RatingContainer